import {assert} from 'Asserts';
import * as BlobActions from 'schemas/tags/BlobActions';
import BlobInputModal from 'schemas/tags/BlobInputModal';
import legacyRunModal from 'ui-library/legacyRunModal';
import {withLoadingScreen} from 'util/Promises';

import {AutomationOutputFileGraphQL} from '../../../graphql-fragments/lab-automation/__generated/AutomationOutputFileGraphQL';
import * as AutomationFileDAO from './AutomationFileDAO';

/**
 * Allow uploading up to the number of output files specified.
 *
 * The return type is the set of output files that were updated.
 */

export default function bulkUpdateAutomationOutputFileBlobs(
  runId: string,
  availableOutputFiles: Array<AutomationOutputFileGraphQL>,
  onUpdate: (updatedOutputFiles: Array<AutomationOutputFileGraphQL>) => void
): void {
  legacyRunModal(BlobInputModal, {
    allowMultiple: true,
    maxFiles: availableOutputFiles.length,
    onUploadFiles: (files: Array<File>) =>
      BlobActions.uploadFilesAsBlobs(files, {
        shouldGeneratePreviewFile: false,
        onBlobsCreated: async (newBlobs) => {
          if (!newBlobs || newBlobs.length === 0) {
            return;
          }
          assert(
            newBlobs.length <= availableOutputFiles.length,
            'Tried to upload more blobs than allowed in automation output file'
          );
          const response = await withLoadingScreen(
            AutomationFileDAO.bulkUpdateAutomationOutputFileBlobs({
              runId,
              outputFiles: newBlobs.map((blob, i) => ({
                configName: availableOutputFiles[i].automationOutputFileConfig.name,
                blobId: blob.id,
              })),
            }),
            'Updating run...'
          );
          onUpdate(response.automationOutputFiles);
        },
      }),
  });
}
